import React, { ReactNode } from 'react';
import styles from './styles.module.css';
import EyeBrow from '../Eyebrow';
import Button from '@/components/common/Button';
import { useTranslations } from 'next-intl';
import MainIcons from '@/icons/main';
import AppLink from '@/components/common/AppLink';
import Badge from '../Badge';

export default function SectionHead({
  title = '',
  text = '',
  tag = '',
  titleClass = '',
  textTitle = '',
  wrapper = '',
  theme = 'light',
  sizes = '',
  children,
  greenCrumb = false,
  headingTag = 'h2',
  textTag = 'p',
  showMore = false,
  buttonText = '',
  buttonChild,
  href = '',
  tagClass = '',
  tagHref,
  badge,
  type = 'section',
  titleChild,
  accountHero = false,
  position = 'normal',
  buttonClass = '',
}: {
  title?: string | ReactNode;
  text?: string | ReactNode;
  tag?: string;
  titleClass?: string;
  textTitle?: string;
  wrapper?: string;
  theme?: 'light' | 'dark';
  sizes?: string;
  children?: ReactNode;
  greenCrumb?: boolean;
  headingTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
  textTag?: 'p' | 'h3' | 'h2';
  showMore?: boolean;
  buttonText?: string;
  buttonChild?: ReactNode;
  href?: string;
  tagClass?: string;
  tagHref?: string;
  badge?: string;
  type?: 'hero' | 'section' | 'accountHero' | 'otherPages';
  titleChild?: ReactNode;
  accountHero?: boolean;
  position?: 'center' | 'normal';
  buttonClass?: string;
}) {
  console.log('greenCrumb==', greenCrumb);
  const tCommon = useTranslations('common');
  const Heading = headingTag;
  const Text = textTag;
  return (
    <div
      className={`${styles.section_head} ${position == 'center' && styles.centerWrapper} ${wrapper}`}
    >
      <div className={`${styles.section_head__left}`}>
        {tag && (
          // <EyeBrow text={tag} greenCrumb={greenCrumb} className={tagClass} tagHref={tagHref} />
          <span className={`${styles.tag} ${tagClass}`}>{tag}</span>
        )}
        {badge && <Badge text={badge} />}
        {title && (
          <div
            className={`${styles.titleContainer}  ${position == 'center' && styles.centerTitleContainer} `}
          >
            <Heading
              className={`${styles.section_title} ${type == 'section' && styles.sectionTitle} ${type == 'accountHero' && styles.heroTitle} ${type == 'otherPages' && styles.otherPagesTitle} ${position == 'center' && styles.centerTitle}  ${titleClass}`}
            >
              {title}
            </Heading>
            {titleChild}
          </div>
        )}
        {text && (
          <Text
            className={`${styles.section_sub} ${type == 'section' && styles.sectionText} ${(type == 'accountHero' || type == 'otherPages') && styles.heroText} ${position == 'center' && styles.centerText} ${textTitle}`}
          >
            {text}
          </Text>
        )}
        {children}
      </div>
      {showMore && (
        <AppLink href={href}>
          <Button className={`btn btn-ghost cursor-pointer ${buttonClass}`}>
            {buttonText ? buttonText : tCommon('viewAll')}
            <MainIcons.arrowIcon className={`rotateIcon-rtl`} />
          </Button>
        </AppLink>
      )}
      {buttonChild}
    </div>
  );
}
